import { TaskCenterAdmin } from '../../../shared/components/TaskCenter/TaskCenterAdmin';
import { Preferences } from '../../../shared/components/Preferences';
import { Orders } from './Orders';
import { Products } from './Products';
import Warehouses from './Warehouses';
import { WhatsAppService } from './WhatsAppService';
import { WSIN } from './WSIN';
import { ESubAdminRoles } from '../AdminIUser/constants';

const sideBarSections = ['Orders', 'Products', 'WSIN', 'Warehouses', 'Preferences', 'Whatsapp Service', 'TaskCenterAdmin'];
const FinAuditorSections = ['Orders'];

export const sidebarUtil = (userRole: string) => {
	let sideBarArray = userRole === ESubAdminRoles.FIN_AUDITOR ? FinAuditorSections : sideBarSections;
	return {
		sideBar: sideBarArray.map((item, index) => ({
			key: index + 1,
			label: item,
			icon: 'allSvgIcon'
		}))
	};
};

interface IGetBrandsSubPageMapper {
	brand: { id: string };
	subAdminRole: string;
	setAdminCatalogueSelectedKeys: () => {};
	adminCatalogueSelectedKeys: string[];
}

export function getBrandsSubPageMapper({ brand, setAdminCatalogueSelectedKeys, adminCatalogueSelectedKeys }: IGetBrandsSubPageMapper) {
	return {
		1: <Orders brand={brand} />,
		2: (
			<Products
				brand={brand}
				setAdminCatalogueSelectedKeys={setAdminCatalogueSelectedKeys}
				adminCatalogueSelectedKeys={adminCatalogueSelectedKeys}
			/>
		),
		3: <WSIN brand={brand} />,
		4: <Warehouses brand={brand} />,
		5: <Preferences isAdmin={true} companyId={brand.id} />,
		6: <WhatsAppService brand={brand} />,
		7: <TaskCenterAdmin isAdmin={true} companyId={brand.id} />
	};
}
